// Centralized data-testid constants for TyresPro Ltd
export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkAreas: "nav-link-areas",
  linkFleet: "nav-link-fleet",
  linkFaq: "nav-link-faq",
  linkContact: "nav-link-contact",
  ctaCall: "nav-cta-call",
  ctaWhatsapp: "nav-cta-whatsapp",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  section: "hero-section",
  heading: "hero-heading",
  subheading: "hero-subheading",
  callBtn: "hero-call-btn",
  whatsappBtn: "hero-whatsapp-btn",
  badge: "hero-badge",
};

export const SERVICES = {
  section: "services-section",
  card: (key) => `service-card-${key}`,
};

export const AREAS = {
  section: "areas-section",
  marquee: "areas-marquee",
};

export const FLEET = {
  section: "fleet-section",
  image: "fleet-van-image",
  callBtn: "fleet-call-btn",
};

export const FAQ = {
  section: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  inputName: "contact-input-name",
  inputPhone: "contact-input-phone",
  inputLocation: "contact-input-location",
  inputTyreSize: "contact-input-tyre-size",
  inputMessage: "contact-input-message",
  submit: "contact-submit-btn",
  phone: "contact-phone",
  email: "contact-email",
  whatsapp: "contact-whatsapp",
};

export const FOOTER = {
  section: "footer-section",
  callBig: "footer-call-big",
};

export const FLOATING = {
  call: "floating-call-btn",
  whatsapp: "floating-whatsapp-btn",
};
